(function($) {

  $('.Game')
  .each(function() {

    const $game = $(this)

    const $inputagree = $game.find('.Useragree').eq(0)
    const inputagreedata = $inputagree.data()
    const $enterbutton = $game.find('.Enterbutton').eq(0)
    const $termslink = $game.find('a.TermsLink').eq(0)
    
    $('body').append('<div id="TermsDialog"></div>')

    $('#TermsDialog')
    .dialog({
      autoOpen: false,
      height: 400,
      width: 300,
      modal: true
    })

    $inputagree.on('click', function() { 
    
      const $this = $(this)
      const checked = $this.is(':checked')

      if(!checked) {

        $enterbutton.prop('disabled', true)

      } else {

        $enterbutton.prop('disabled', false)
      }
    })

    $enterbutton.on('click', function() {

      const $this = $(this)
      const gameid = $this.data('gameid')
      const userid = $this.data('userid')
      const url = $this.attr('href')

      $enterbutton.prop('disabled', true)

      if(inputagreedata['agreement']) {

        window.location.href = '/?gameid=' . gameid

      } else {      

        $.ajax({
          url: `/wp-json/playmotivcloud/core/v4/aws?path=/agreements/${gameid}/${userid}`, 
          method: 'POST',
          success: function(result){

            window.location.href = '/?gameid=' . gameid
          },
          error: function(error) {

            console.log(error.responseJSON.message)
      
            $enterbutton.prop('disabled', false)
          }
        });
      }
    })

    if(inputagreedata['agreement']) {

      $inputagree.prop('checked', true)
      $inputagree.prop('disabled', true)
      $enterbutton.prop('disabled', false)

    } else {

      $enterbutton.prop('disabled', true)
    }

    $termslink.on('click', function() {
    
      const $this = $(this)
      const contentid = $this.attr('href')
      const contenturl = `/wp-json/playmotivcloud/core/v4/htmlcontent/${ contentid }`

      fetch(contenturl)
      .then(result => result.json()
        .then(content => $('#TermsDialog').html(content))
      )

      $('#TermsDialog').dialog('open')

      return false
    })
  })

})(jQuery)